import { createSelector } from 'reselect';

import {
  FETCH_ADMIN_STATS_DAT_SUCCESS,
  FETCH_ADMIN_STATS_JSON_SUCCESS,
} from '../../actions/adminStats';

import {
  extractAdminStats
} from '../../utils/common';

import adminStatistics from '../../utils/adminStatistics';

const initialState = {
  adminStatsDat: [],
  adminStatsJson: {},
};

export default function adminStatsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_ADMIN_STATS_DAT_SUCCESS:
      return {
        ...state,
        adminStatsDat: extractAdminStats(action.payload.data),
    };
    case FETCH_ADMIN_STATS_JSON_SUCCESS:
      return {
        ...state,
        adminStatsJson: action.payload.data,
      };
    default:
      return state;
  }
}

const getAdminStatsDat = state => state.adminStats.adminStatsDat;
const getAdminStatsJson = state => state.adminStats.adminStatsJson;

export const adminStatisticsSelector = createSelector(
  [getAdminStatsDat, getAdminStatsJson],
  (adminStatsDat, adminStatsJson) =>
    adminStatistics.getAdminStatistics(adminStatsDat, adminStatsJson)
);

export const  adminStatisticsWithTimePeriodSelector = (startDate, endDate) => createSelector(
    [getAdminStatsDat, getAdminStatsJson],
    (adminStatsDat, adminStatsJson) =>
        adminStatistics.getAdminStatisticsWithTimePeriod(
            adminStatsDat,
            adminStatsJson,
            startDate,
            endDate,
        )
);
